
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as scangh1lFrGjsiUoCiScfLOaTHOeFimtxeyDyUL4XPpGOxcMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/scan.vue?macro=true";
import { default as clearszRd5WUe4JYmoLivbmjPy4o2dv4KM9_K0EVGBYK5a7oMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/clear.vue?macro=true";
import { default as index0ABmEz_Zt3kT6FKAPHTfeBnWpvHcIQnsC7P7_45FCVia0Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/index.vue?macro=true";
import { default as login73GQuZEo__45OTX_p8EzXlcPx69WgboJIwAFk0u6aKLjoMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/login.vue?macro=true";
import { default as updateVd4yW_MrJbON_qZhbhrhOqN32ucOA_45sj3MPAWsbHSpgMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/update.vue?macro=true";
import { default as qrr7__45pbthJtDm2V12JizBvKUk_45inf3STljs42UoFrSdgMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/qr.vue?macro=true";
import { default as infolfbUQHMl6I5Z1tY_45AObt19reTFyYwViW2n3mA2pemmAMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/info.vue?macro=true";
import { default as applyQYo5mbFdBZVMYq2l8P8YebgrxzxP7GYoW_45_45Zd7rdcEwMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/apply.vue?macro=true";
import { default as aboutCx9uAqv_45Xf8PBNuuSh_GTIF0TboY4ptmOJYyQJwkhZsMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/about.vue?macro=true";
import { default as previewAPlsmn463mS9ppd6czoh4M1vuhxqtMY_U6Zdcp4yTosMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/preview.vue?macro=true";
import { default as indexm92nxUxXcEVJ_yjGIJbrX4PqeiUjMp2GAwV3Bi0kOZ4Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/schedule/[day]/index.vue?macro=true";
import { default as _91item_93cnB_u7EE20VloOdraMohURhnQ0G0MBhNu1__45AL2G8N4Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/schedule/[day]/[item].vue?macro=true";
import { default as _91_91edit_93_93ER5Pe6nVuT6rfmBhlEQ0lDv8OZvW0nIy6h3rMTNGPd8Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/schedule/[day]/edit/[[edit]].vue?macro=true";
import { default as scheduledHKY9ibBU_450CydOMX_45LlFfPgDgE0IK3nrW82gDi0qBEMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/schedule.vue?macro=true";
import { default as settingsYRHz4aht_SKJb4yHX7tSe_45ySOi7LuGviQ_45ayk1bkZB0Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/settings.vue?macro=true";
import { default as privacy2bbbpzYtYABNsuxv9RxJ3aQRdzG5tPzQyZCOhrGvB_oMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/privacy.vue?macro=true";
import { default as indexxPTtLIPznclewwJWFkRdnA_45db18j_45ljtSu_455QyXLi3UMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/index.vue?macro=true";
import { default as usersbMjACWzHfhOhL9IZpoQ35sPJRZAVETcLkeo6qk7V824Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/users.vue?macro=true";
import { default as duties_45JYjfyYGqvDk27UJksDs50KitzFd88BNkahI0R5MfhEMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/participant/duties.vue?macro=true";
import { default as groupsbricbFrx4xLMz5q5aj4y_LXqBdPQSpy_km3yD2HY6PIMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/participant/groups.vue?macro=true";
import { default as applicationhxoi7MzOjtOJtMVvbYxCqAKS_8lCcUzBRhsWiFwczKIMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/participant/application.vue?macro=true";
import { default as participantkHdSf700L0eBkXDN7Hsy8OHwPyPbMigsqfo9zUQN8YwMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/participant.vue?macro=true";
import { default as dutiesH9QPAZulZPP_45oBjJnYs3EjLp8ExZNOl7B__g0pCe0P0Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people/duties.vue?macro=true";
import { default as groupshPCg6A6VoBuT0kuJvZw_45_45YiAl5e6vSLHdebyc2v9XXoMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people/groups.vue?macro=true";
import { default as statisticsx9pG3N_qXH0XW6XYqMXKwbxBi_45GTCtYhZGc9R4hOqB0Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people/statistics.vue?macro=true";
import { default as applications1GMwPIE7xWBpsvhkGUJF0DawLAYbtlGNNYHbm6FuyZcMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people/applications.vue?macro=true";
import { default as peopleUJ9eQ5QVFQKvI8ux0R_mCl9f7_5ZRbJZvJ310wCeACYMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people.vue?macro=true";
import { default as indexquKoyBx2rs_45t5_hTGHv_459OkCWrZHVK9v49vyBp6BB_gMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/feedback/index.vue?macro=true";
import { default as thanksg4eqpzBmm52GfwAl5JxxzeF30OhXX0toQmWaN_45ig_45KcMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/feedback/thanks.vue?macro=true";
import { default as formWCU_458ql5bIxZGYtjPTHrydeERNdl1ChoizVem56CZtgMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/events/form.vue?macro=true";
import { default as editVVAJnrAhj9LimxZOa8Lt3A1rPX85Llg6ZqdlHOmZNaQMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/admin/events/edit.vue?macro=true";
import { default as _91feedback_93XB9vgExaLjGbujSyAirWitnF3bpaEcaAT6PTcMlngWkMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/feedback/[feedback].vue?macro=true";
import { default as indexnie8opWLiRm3ST1Gy7bYafvYWoIWt23qvN7ki9hQbbQMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/admin/events/index.vue?macro=true";
import { default as indexqndiK3kOZJgkMiN6RNDjOu_45LdnDURIucjXVpV_45cBnKUMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/feedback/index.vue?macro=true";
import { default as exportGgdpXshd__45p7LReVUB9jqiK0iNMevv4Jsh8VkpCXMuMMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/admin/events/export.vue?macro=true";
import { default as importnsLnaX3EgStGr9GsvN9vDBzLOj0C0Hw_45t89024riydIMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/admin/events/import.vue?macro=true";
import { default as otheruAryNQAefLoy7ReG9_455EAVjchwusaSx0g2KjAT3EqzoMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/feedback/result/other.vue?macro=true";
import { default as programSG5ghGjfToM5JcrEkWyj38e8SazJ7p3V1cdrM0FcxgwMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/feedback/result/program.vue?macro=true";
import { default as resultKssLWrTFOt7ipdbpxzm8quQcy_45tw2bJtOqXISIEG0N0Meta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/feedback/result.vue?macro=true";
import { default as index9S8G_vs8GaymNkGzXlP0FfBqvtjGN5Ibf5SzxwpojmcMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/transfer/[transfer]/index.vue?macro=true";
import { default as _91code_93mkJUzs8GUHdeY7BL0_45G3Y2Qc4zmxMvk6mBFudRA43bkMeta } from "/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/transfer/[transfer]/[code].vue?macro=true";
export default [
  {
    name: "scan",
    path: "/scan",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/scan.vue")
  },
  {
    name: "clear",
    path: "/clear",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/clear.vue")
  },
  {
    name: "front-page",
    path: "/:event?",
    meta: index0ABmEz_Zt3kT6FKAPHTfeBnWpvHcIQnsC7P7_45FCVia0Meta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/login.vue")
  },
  {
    name: "update",
    path: "/update",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/update.vue")
  },
  {
    name: "qr",
    path: "/:event?/qr",
    meta: qrr7__45pbthJtDm2V12JizBvKUk_45inf3STljs42UoFrSdgMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/qr.vue")
  },
  {
    name: "event-info",
    path: "/:event()/info",
    meta: infolfbUQHMl6I5Z1tY_45AObt19reTFyYwViW2n3mA2pemmAMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/info.vue")
  },
  {
    name: "event-apply",
    path: "/:event()/apply",
    meta: applyQYo5mbFdBZVMYq2l8P8YebgrxzxP7GYoW_45_45Zd7rdcEwMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/apply.vue")
  },
  {
    name: "event-about",
    path: "/:event?/about",
    meta: aboutCx9uAqv_45Xf8PBNuuSh_GTIF0TboY4ptmOJYyQJwkhZsMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/about.vue")
  },
  {
    name: "event-preview",
    path: "/:event()/preview",
    meta: previewAPlsmn463mS9ppd6czoh4M1vuhxqtMY_U6Zdcp4yTosMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/preview.vue")
  },
  {
    name: "event-schedule",
    path: "/:event()/schedule",
    meta: scheduledHKY9ibBU_450CydOMX_45LlFfPgDgE0IK3nrW82gDi0qBEMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/schedule.vue"),
    children: [
  {
    name: "event-schedule-day",
    path: ":day()",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/schedule/[day]/index.vue")
  },
  {
    name: "event-schedule-day-item",
    path: ":day()/:item()",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/schedule/[day]/[item].vue")
  },
  {
    name: "event-schedule-day-edit-edit",
    path: ":day()/edit/:edit?",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/schedule/[day]/edit/[[edit]].vue")
  }
]
  },
  {
    name: "settings",
    path: "/:event()/settings",
    meta: settingsYRHz4aht_SKJb4yHX7tSe_45ySOi7LuGviQ_45ayk1bkZB0Meta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/settings.vue")
  },
  {
    name: "privacy",
    path: "/:event?/privacy",
    meta: privacy2bbbpzYtYABNsuxv9RxJ3aQRdzG5tPzQyZCOhrGvB_oMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/privacy.vue")
  },
  {
    name: "event-admin",
    path: "/:event()/admin",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/index.vue")
  },
  {
    name: "event-admin-users",
    path: "/:event()/admin/users",
    meta: { ...(usersbMjACWzHfhOhL9IZpoQ35sPJRZAVETcLkeo6qk7V824Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/users.vue")
  },
  {
    name: "event-participant",
    path: "/:event()/participant",
    meta: participantkHdSf700L0eBkXDN7Hsy8OHwPyPbMigsqfo9zUQN8YwMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/participant.vue"),
    children: [
  {
    name: "duties",
    path: "duties",
    meta: duties_45JYjfyYGqvDk27UJksDs50KitzFd88BNkahI0R5MfhEMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/participant/duties.vue")
  },
  {
    name: "groups",
    path: "groups",
    meta: groupsbricbFrx4xLMz5q5aj4y_LXqBdPQSpy_km3yD2HY6PIMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/participant/groups.vue")
  },
  {
    name: "applocation",
    path: "application",
    meta: applicationhxoi7MzOjtOJtMVvbYxCqAKS_8lCcUzBRhsWiFwczKIMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/participant/application.vue")
  }
]
  },
  {
    name: "event-admin-people",
    path: "/:event()/admin/people",
    meta: peopleUJ9eQ5QVFQKvI8ux0R_mCl9f7_5ZRbJZvJ310wCeACYMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people.vue"),
    children: [
  {
    name: "event-admin-people-duties",
    path: "duties",
    meta: { ...(dutiesH9QPAZulZPP_45oBjJnYs3EjLp8ExZNOl7B__g0pCe0P0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people/duties.vue")
  },
  {
    name: "event-admin-people-groups",
    path: "groups",
    meta: { ...(groupshPCg6A6VoBuT0kuJvZw_45_45YiAl5e6vSLHdebyc2v9XXoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people/groups.vue")
  },
  {
    name: "event-admin-people-statistics",
    path: "statistics",
    meta: { ...(statisticsx9pG3N_qXH0XW6XYqMXKwbxBi_45GTCtYhZGc9R4hOqB0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people/statistics.vue")
  },
  {
    name: "event-admin-people-applications",
    path: "applications",
    meta: applications1GMwPIE7xWBpsvhkGUJF0DawLAYbtlGNNYHbm6FuyZcMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/people/applications.vue")
  }
]
  },
  {
    name: "event-feedback",
    path: "/:event()/feedback",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/feedback/index.vue")
  },
  {
    name: "event-feedback-thanks",
    path: "/:event()/feedback/thanks",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/feedback/thanks.vue")
  },
  {
    name: "event-admin-events-form",
    path: "/:event()/admin/events/form",
    meta: { ...(formWCU_458ql5bIxZGYtjPTHrydeERNdl1ChoizVem56CZtgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/events/form.vue")
  },
  {
    name: "event-admin-events-edit",
    path: "/:event?/admin/events/edit",
    meta: { ...(editVVAJnrAhj9LimxZOa8Lt3A1rPX85Llg6ZqdlHOmZNaQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/admin/events/edit.vue")
  },
  {
    name: "event-feedback-feedback",
    path: "/:event()/feedback/:feedback()",
    meta: _91feedback_93XB9vgExaLjGbujSyAirWitnF3bpaEcaAT6PTcMlngWkMeta || {},
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/feedback/[feedback].vue")
  },
  {
    name: "event-admin-events",
    path: "/:event?/admin/events",
    meta: { ...(indexnie8opWLiRm3ST1Gy7bYafvYWoIWt23qvN7ki9hQbbQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/admin/events/index.vue")
  },
  {
    name: "event-admin-feedback",
    path: "/:event()/admin/feedback",
    meta: { ...(indexqndiK3kOZJgkMiN6RNDjOu_45LdnDURIucjXVpV_45cBnKUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/feedback/index.vue")
  },
  {
    name: "event-admin-events-export",
    path: "/:event?/admin/events/export",
    meta: { ...(exportGgdpXshd__45p7LReVUB9jqiK0iNMevv4Jsh8VkpCXMuMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/admin/events/export.vue")
  },
  {
    name: "event-admin-events-import",
    path: "/:event?/admin/events/import",
    meta: { ...(importnsLnaX3EgStGr9GsvN9vDBzLOj0C0Hw_45t89024riydIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[[event]]/admin/events/import.vue")
  },
  {
    name: "event-admin-feedback-result",
    path: "/:event()/admin/feedback/result",
    meta: { ...(resultKssLWrTFOt7ipdbpxzm8quQcy_45tw2bJtOqXISIEG0N0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/feedback/result.vue"),
    children: [
  {
    name: "event-admin-feedback-result-other",
    path: "other",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/feedback/result/other.vue")
  },
  {
    name: "event-admin-feedback-result-program",
    path: "program",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/admin/feedback/result/program.vue")
  }
]
  },
  {
    name: "event-transfer-transfer",
    path: "/:event()/transfer/:transfer()",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/transfer/[transfer]/index.vue")
  },
  {
    name: "event-transfer-transfer-code",
    path: "/:event()/transfer/:transfer()/:code()",
    component: () => import("/home/mousa/Documents/Projecty/lst-navigator/pages/[event]/transfer/[transfer]/[code].vue")
  }
]